import { apiHelper, sessionHelper } from "@/utils";
import qs from "qs";
import { API } from "@/constants";
import { userService } from "./user.service";
const permissionLevel = () =>
  Math.max(
    sessionHelper.getPermissionLevel("developer"),
    sessionHelper.getPermissionLevel("user_admin"),
  );
async function exportedUsers(blob) {
  if (blob instanceof Blob && blob.size > 0 && !/json|html/i.test(blob.type))
    return blob;
  let data = blob;
  if (blob instanceof Blob) {
    try {
      data = JSON.parse(await blob.text());
    } catch (error) {
      throw new Error("Invalid export response.");
    }
  }
  const details = data?.errors || data?.error;
  throw new Error(
    data?.message ||
      (typeof details === "string"
        ? details
        : details
        ? Object.values(details).flat().join(" ")
        : "") ||
      "Invalid export response.",
  );
}
export const userPermissionDefinitionService = {
  bulkUpdate(permissionKey, level, userUUIDs = [], selectAll = false) {
    if (sessionHelper.getPermissionLevel("user_admin") !== 2)
      return Promise.reject(new Error("Permission denied."));
    if (
      !/^[a-z][a-z0-9_]*$/.test(permissionKey) ||
      !Number.isInteger(level) ||
      level < 0 ||
      typeof selectAll !== "boolean" ||
      (!selectAll &&
        (!Array.isArray(userUUIDs) ||
          !userUUIDs.length ||
          userUUIDs.some((uuid) => typeof uuid !== "string" || !uuid.trim())))
    )
      return Promise.reject(new Error("Invalid bulk permission update."));
    return apiHelper(`${API.BASE_URL_API}/v1`).patch(
      "/users/permissions/bulk",
      {
        select_all: selectAll,
        ...(!selectAll ? { user_uuids: [...new Set(userUUIDs)] } : {}),
        permission_key: permissionKey,
        permission_level: level,
      },
    );
  },
  async exportUsers(permissionKey, level, filter = {}) {
    if (permissionLevel() < 1) throw new Error("Permission denied.");
    if (
      !/^[a-z][a-z0-9_]*$/.test(permissionKey) ||
      !Number.isInteger(level) ||
      level < 0
    )
      throw new Error("Invalid permission filter.");
    const params = { permission_key: permissionKey, level };
    if (filter.searchWords?.length) params.search_words = filter.searchWords;
    try {
      const blob = await apiHelper(`${API.BASE_URL_API}/v1`).get(
        "/users/by-permission/export",
        {
          params,
          responseType: "blob",
          paramsSerializer: (query) =>
            qs.stringify(query, {
              arrayFormat: "brackets",
              encodeValuesOnly: true,
            }),
        },
      );
      return await exportedUsers(blob);
    } catch (error) {
      if (error?.response?.data instanceof Blob)
        return exportedUsers(error.response.data);
      throw error;
    }
  },
  getUsers(permissionKey, level, filter = {}) {
    if (permissionLevel() < 1)
      return Promise.reject(new Error("Permission denied."));
    if (
      !/^[a-z][a-z0-9_]*$/.test(permissionKey) ||
      !Number.isInteger(level) ||
      level < 0
    )
      return Promise.reject(new Error("Invalid permission filter."));
    const params = {
      permission_key: permissionKey,
      level,
      page: filter.page || 1,
      size: filter.size || 15,
    };
    if (filter.searchWords?.length) params.search_words = filter.searchWords;
    return apiHelper(`${API.BASE_URL_API}/v1`).get("/users/by-permission", {
      params,
      paramsSerializer: (query) =>
        qs.stringify(query, {
          arrayFormat: "brackets",
          encodeValuesOnly: true,
        }),
    });
  },
  getAll() {
    if (permissionLevel() < 1)
      return Promise.reject(new Error("Permission denied."));
    return userService.getPermissionDefinitions();
  },
  update(uuid, data) {
    if (permissionLevel() < 2)
      return Promise.reject(new Error("Permission denied."));
    return apiHelper(`${API.BASE_URL_API}/v1`).put(
      `/user-permissions/definitions/${encodeURIComponent(uuid)}`,
      { name: data.name.trim(), description: data.description.trim() },
    );
  },
};
